import { render, staticRenderFns } from "./base-header.vue?vue&type=template&id=13858c2e"
import script from "./base-header.vue?vue&type=script&lang=js"
export * from "./base-header.vue?vue&type=script&lang=js"
import style0 from "./base-header.vue?vue&type=style&index=0&id=13858c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports